export default __webpack_public_path__ + "static/og-image-7f02cf5fa4d6736396eebbbfa02c2e1a.jpg";